import { create } from "zustand";
import { axiosHelper, tokenHelper } from "../helpers";

export const useSpacePopupStore = create((set, get) => ({
  spacePopups: [],
  isLoading: false,
  isError: false,
  error: undefined,
  pagination: null,

  // Get all space popups
  getSpacePopups: async (params = {}) => {
    try {
      const accessToken = await tokenHelper.getToken();
      set({ isLoading: true });
      let response = await axiosHelper.get("/space-popup", {
        headers: { Authorization: `Bearer ${accessToken}` },
        params: params,
      });

      set({
        spacePopups: response?.items || [],
        totalRows: response?.pagination?.totalItems || 0,
        isLoading: false,
      });
      return response;
    } catch (e) {
      console.log(e);
      set({ isLoading: false, isError: true, error: e });
    }
  },

  // Get single space popup
  getSpacePopup: async (id) => {
    try {
      const accessToken = await tokenHelper.getToken();
      set({ isLoading: true });

      let response = await axiosHelper.get(`/space-popup/${id}`, {
        headers: { Authorization: `Bearer ${accessToken}` },
      });

      set({ isLoading: false });
      return response;
    } catch (e) {
      console.log(e);
      set({ isLoading: false, isError: true, error: e });
    }
  },

  // Create space popup
  createSpacePopup: async (formData) => {
    try {
      const accessToken = await tokenHelper.getToken();
      set({ isLoading: true });

      let response = await axiosHelper.post("/space-popup", formData, {
        headers: {
          Authorization: `Bearer ${accessToken}`,
          "Content-Type": "multipart/form-data",
        },
      });

      // Refresh the list
      await get().getSpacePopups();
      set({ isLoading: false });
      return response;
    } catch (e) {
      console.log(e);
      set({ isLoading: false, isError: true, error: e });
    }
  },

  // Update space popup
  updateSpacePopup: async (id, formData) => {
    try {
      const accessToken = await tokenHelper.getToken();
      set({ isLoading: true });

      let response = await axiosHelper.patch(`/space-popup/${id}`, formData, {
        headers: {
          Authorization: `Bearer ${accessToken}`,
          "Content-Type": "multipart/form-data",
        },
      });

      // Refresh the list
      await get().getSpacePopups();
      set({ isLoading: false });
      return response;
    } catch (e) {
      console.log(e);
      set({ isLoading: false, isError: true, error: e });
    }
  },

  // Delete space popup
  deleteSpacePopup: async (id) => {
    try {
      const accessToken = await tokenHelper.getToken();
      set({ isLoading: true });

      let response = await axiosHelper.delete(`/space-popup/${id}`, {
        headers: { Authorization: `Bearer ${accessToken}` },
      });

      // Refresh the list
      await get().getSpacePopups();
      set({ isLoading: false });
      return response;
    } catch (e) {
      console.log(e);
      set({ isLoading: false, isError: true, error: e });
    }
  },
}));

